(function(){
  var V=JSON.parse((document.currentScript&&document.currentScript.getAttribute("data-v"))||"{}"),co=V.co;
  function isApp(o){return o===location.origin||/^https:\/\/[a-z0-9-]+\.spacesheep\.dev$/.test(o);}
  window.addEventListener("message",function(e){
    if(e.origin!==co||!e.data||e.data.type!=="ss-open"||typeof e.data.href!=="string")return;
    var f=document.getElementById("content");
    if(!f||e.source!==f.contentWindow)return;
    // The page is its author's script and can post ss-open whenever it likes; a link
    // the reader clicked activates this window too (a click in a frame reaches every
    // ancestor), so a navigation nobody clicked is refused.
    var ua=navigator.userActivation;if(ua&&!ua.isActive)return;
    var u;try{u=new URL(e.data.href);}catch(x){return;}
    if(!isApp(u.origin))return;
    if(u.origin===location.origin&&(u.pathname==="/signin"||u.pathname==="/login")){
      var n=u.searchParams.get("next")||"";
      if(n.charAt(0)!=="/"||n.charAt(1)==="/")u.searchParams.set("next",location.pathname+location.search);
    }
    try{e.source.postMessage({type:"ss-open-ack"},co);}catch(x){}
    location.href=u.href;
  });
})();